// TODO: JFED-002 - Update Swiper to latest
import * as globals from './globals.js';
const Swiper = require('swiper');

export default class smallGallery {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    this.initCarousel();
  }

  initCarousel() {
    const galleryWrapper = this.el.querySelector('.carousel--wrapper'),
      galleryItems = this.el.querySelector('.carousel--items'),
      galleryItemsLength = this.el.querySelectorAll('.carousel--item');

    galleryWrapper.classList.add('is-carousel');

    const galleryNav = document.createRange().createContextualFragment(`
      <button class="carousel--prev"><i class="fa fa-chevron-left"></i><span>Previous slide</span></button>
      <button class="carousel--next"><i class="fa fa-chevron-right"></i><span>Next slide</span></button>
    `);

    galleryWrapper.parentNode.appendChild(galleryNav);

    const galleryNext = this.el.querySelector('.carousel--next'),
      galleryPrev = this.el.querySelector('.carousel--prev');

    this.carousel = new Swiper(galleryWrapper, {
      autoHeight: false,
      slidesPerView: 'auto',
      spaceBetween: 10,
      loop: true,
      loopedSlides: 3,
      observer: true,
      slideClass: 'carousel--item',
      wrapperClass: 'carousel--items',
      nextButton: galleryNext,
      prevButton: galleryPrev,
      breakpoints: {
        480: {
          slidesPerView: 1.2,
        },
      },
    });
  }
}
